// The completion info box under a product highlight (modules/collections/templates/completion-info-box.php).
// Logged-in pages are one cached copy for every customer, so the widget only prints an empty
// slot and the box is fetched here; nothing to complete leaves the slot empty. The nonce
// comes from personal-price.js, which keeps the last working one.

import { restFetch } from './personal-price';

async function fill(slot) {
    const url = new URL(slot.dataset.sonCompletionInfoEndpoint, window.location.href);
    url.searchParams.set('product_id', slot.dataset.sonCompletionInfo);

    const { response, json } = await restFetch(url.toString());
    if (response.ok && json?.html) {
        slot.outerHTML = json.html;
    }
}

document.addEventListener('DOMContentLoaded', () => {
    const slots = document.querySelectorAll('[data-son-completion-info]');
    if (!slots.length || !window.sonPersonalPrice) {
        return;
    }

    slots.forEach((slot) => {
        fill(slot).catch(() => {
            // no box is a fine fallback
        });
    });
});
